import pLogo from 'assets/images/p-logo.svg';
import PropTypes from 'prop-types';
import React from 'react';
import { dateAddDays, formatDate } from '../../../utils/dates/date';
import BetList from '../BetList';
import { BETS_CHUNK_DAYS } from '../constants';
import LoadPreviousWeek from '../LoadPreviousWeek';

const EverythingElse = ({ hasBets, bets, moreBets, showLoadPreviousWeek = false }) => (
  <div className="everything-else">
    <div>
      <h2 className="everything-else__header">
        <img src={pLogo} className="everything-else__p-logo" /> = Online funded bet
      </h2>
      <p className="everything-else__note">
        Returns are automatically deposited into your online account.
      </p>
      {
        hasBets
          ? (<BetList bets={bets} />)
          : (<p className="everything-else__more-empty">No activity</p>)
      }
    </div>
    {moreBets.map(({ sinceDate, ids }) => (
      <div key={sinceDate}>
        <div className="everything-else__more-separator" />
        <h3 className="everything-else__more-header">Activity for bets placed on:</h3>
        <p className="everything-else__more-info">
          {formatDate(sinceDate)} &ndash; {formatDate(dateAddDays(sinceDate, BETS_CHUNK_DAYS - 1))}
        </p>
        {
          ids.size
            ? (<BetList bets={ids} />)
            : (<p className="everything-else__more-empty">No activity</p>)
        }
      </div>
    ))}
    {showLoadPreviousWeek && (<LoadPreviousWeek>Load previous week's activity</LoadPreviousWeek>)}
  </div>
);

EverythingElse.propTypes = {
  hasBets: PropTypes.bool.isRequired,
  bets: PropTypes.object.isRequired,
  moreBets: PropTypes.object.isRequired,
  showLoadPreviousWeek: PropTypes.bool
};

export default EverythingElse;
